import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

const label: string = `Team plans are great for schools or businesses looking to create a collaborative
experience for their users. With a team plan, you get:`;

const teamFeatures: string[] = [
  `Gain unlimited access to over 700 anatomy, disease and treatment models`,
  `Save unlimited 3D models`,
  `Embed models directly into your learning management system, website or application`,
  `Improve cross-team collaboration`,
];

@Component({
  selector: 'app-team-features',
  templateUrl: './team-features.component.html',
  styleUrls: ['./team-features.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeamFeaturesComponent implements OnInit {
  @Input()
  label: string = label;

  @Input()
  features: string[] = teamFeatures;

  constructor() {}

  ngOnInit(): void {}
}
